import React, { useState } from "react";
import { DatePicker, Table, Select } from "antd";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { useAttendanceReportQuery } from "AppQuries/report/get-attendance-report";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import TableTop from "Components/UI/TableTop";
import { format } from "date-fns";
import dayjs from "dayjs";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";

import ReportTools from "Components/UI/ReportTools";
import moment from "moment";
import { useFormattedEmployees } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import { BackIcon } from "Components/UI/Icon/Icons";
const { RangePicker } = DatePicker;
const AttendanceReport = () => {
  const userData = useSelector(loggedInUser);

  const [queryParams, setQueryParams] = useState({
    employeeCode: 0,
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),
  });

  const {
    data,
    isFetching,
    isError,
    error,
    refetch: getAttendanceReport,
  } = useAttendanceReportQuery(
    {
      companyCode: userData?.companyCode,
      locationCode: userData?.selectedLocationCode,
      userId: userData?.userID,
      isAllCompanies: userData?.isAllCompanies,
      selectedCompanyCode: userData?.selectedCompanyCode,
      ...queryParams,
    },
    {
      enabled: !!queryParams.fromDate && !!queryParams.toDate,
    }
  );

  const attendanceReport = data?.map((d, _id) => ({
    ...d,
    id: _id + 1,
    attendanceDate: format(new Date(d?.attendanceDate), "dd-MM-yyyy"),
    // attendanceValue:
    //   d.attendanceValue === "1"
    //     ? "Present"
    //     : d.attendanceValue === "0"
    //     ? "Absent"
    //     : "Half Day",
    attendanceInTime:
      d.attendanceValue === "Absent"
        ? " - "
        : moment(d.inTime, ["HH:mm"]).format("hh:mm A"),
    attendanceOutTime:
      d.attendanceValue === "Absent" || d.outTime === null
        ? " - "
        : moment(d.outTime, ["HH:mm"]).format("hh:mm A"),
  }));

  const employeeOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: 0,
  });
  const [isFilterVisible, setIsFilterVisible] = useState(true);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      sorter: (a, b) => a.uniqueID - b.uniqueID,
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      sorter: (a, b) => a.employeeName.length - b.employeeName.length,
    },
    {
      title: "Attendance Date",
      dataIndex: "attendanceDate",
      // sorter: (a, b) => a.attendanceDate.length - b.attendanceDate.length,
    },
    {
      title: "Attendance Value",
      dataIndex: "attendanceValue",
      render: (text, record) => (
        <>
          {record.attendanceValue === "Present" && (
            <div className="badges badge-linesuccess">Present</div>
          )}
          {record.attendanceValue === "Half Day" && (
            <div className="badges badge-linewarning">Half Day</div>
          )}
          {record.attendanceValue === "Absent" && (
            <div className="badges badge-linedanger">Absent</div>
          )}
        </>
      ),
    },
    {
      title: "In Time",
      dataIndex: "attendanceInTime",
    },
    {
      title: "Out Time",
      dataIndex: "attendanceOutTime",
    },
  ];

  const searchColumns = columns.map((column, index) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    attendanceReport,
    searchColumns
  );
  if (isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Attendance Report</h4>
              <h6>View Employee Attendance Progress</h6>
            </div>
          </div>
          <ReportTools
            columns={columns}
            data={attendanceReport}
            fileName={`Attendance Report ${queryParams.fromDate} - ${queryParams.toDate}`}
            pdfTheme="striped"
            refresh={getAttendanceReport}
            isCSV={true}
          />
          <div className="page-btn">
            <Link
              to={`${all_routes.report_list}`}
              f
              className="btn btn-secondary"
            >
              <BackIcon className="me-2" />
              Back
            </Link>
          </div>
          {/* <div className="page-btn">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Generate Payroll</Tooltip>}
            >
              <Link
                to={`${all_routes.payroll}${all_routes.generate_payroll}`}
                className="btn btn-added"
              >
                <PlusCircle className="me-2" />
                Generate Payroll
              </Link>
            </OverlayTrigger>
          </div> */}
        </div>

        <div className="card table-list-card border-0">
          <div className="card-body">
            <TableTop
              onSearch={setSearchValue}
              toggleFilterVisibility={toggleFilterVisibility}
              isFilterVisible={isFilterVisible}
              showToggle={true}
            />
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              // style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="form-row row">
                  <div className="row">
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="" style={{ display: "flex" }}>
                        <div className="form-group">
                          <label className="form-label">
                            Start Date – End Date
                          </label>
                          <RangePicker
                            //   className="form-control"
                            placeholder="From Date"
                            onChange={(date, dateString) => {
                              console.log("date", date);
                              console.log("dateString", dateString);
                              if (date) {
                                updateQueryParams("fromDate", dateString[0]);
                                updateQueryParams("toDate", dateString[1]);
                              }
                            }}
                            defaultValue={[
                              dayjs(queryParams?.fromDate, "YYYY-MM-DD"),
                              dayjs(queryParams?.toDate, "YYYY-MM-DD"),
                            ]}
                            dateFormat="YYYY-MM-DD"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <label className="form-label">Employee</label>
                      <Select
                        className="form-control"
                        options={employeeOptions}
                        placeholder="Select Employee"
                        value={
                          employeeOptions.find(
                            (option) =>
                              option.value === queryParams.employeeCode
                          ) || ""
                        }
                        onChange={(e) => {
                          updateQueryParams("employeeCode", e || 0);
                        }}
                        onClear={(e) => {
                          updateQueryParams("employeeCode", 0);
                        }}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        variant="borderless"
                        style={{ width: "100%" }}
                      />
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <label className="form-label">&nbsp;</label>
                        <Link
                          className="btn btn-filters ms-auto"
                          onClick={getAttendanceReport}
                          type="button"
                        >
                          <i data-feather="search" className="feather-search" />
                          {isFetching ? (
                            <>
                              <i className="fas fa-spinner fa-spin me-2"></i>
                              Loading...
                            </>
                          ) : (
                            <>Filter</>
                          )}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <Table
                className="table  datanew"
                columns={columns}
                dataSource={filteredData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceReport;
